export default "__VITE_ASSET__e9c7936e__"